import { petPortraitHtml } from "./petArt";

/** The chip's portrait size (CSS px) and how long its bounce and its note last (ms, pets.css). */
const PORTRAIT_PX = 40;
const BOUNCE_MS = 520;
const NOTE_MS = 950;

/**
 * (D) The pet's chip on the battle HUD (render/views/petPresent.ts): its round portrait with its level, at the top of
 * the thumb cluster (over the whole-map and turn buttons, beside the rally flag's button). It bounces and shows
 * its note on each bark or pulse (the pup's "+muster", a pulse's own name); a tap centres the camera on the pet. DOM only; the level wires it (level/levelPet.ts).
 */
export class PetHudChip {
  readonly root: HTMLButtonElement;
  private timers: number[] = [];

  constructor(petId: string, name: string, level: number, onTap: () => void) {
    this.root = document.createElement("button");
    this.root.type = "button";
    this.root.className = "pethud";
    this.root.setAttribute("aria-label", `${name}, level ${level}. Tap to find it`);
    this.root.innerHTML = `${petPortraitHtml(petId, PORTRAIT_PX)}<b class="pb disp tnum">${level}</b>`;
    this.root.addEventListener("click", onTap);
  }

  /** A bark or a pulse: the chip bounces, and its note (petWords.ts chipNote: "+muster", "Lantern Flare!") rises off it. */
  bark(word: string): void {
    const r = this.root;
    r.classList.remove("bounce");
    void r.offsetWidth;                                   // restart the animation
    r.classList.add("bounce");
    const note = document.createElement("span");
    note.className = "pn disp";
    note.textContent = word;
    r.append(note);
    this.timers.push(window.setTimeout(() => r.classList.remove("bounce"), BOUNCE_MS), window.setTimeout(() => note.remove(), NOTE_MS));
  }

  dispose(): void { for (const t of this.timers) window.clearTimeout(t); this.timers = []; this.root.remove(); }
}

/** The word a pulse shouts (C: the pup's "WOOF!", petWords.ts petShout), at screen point (x, y) CSS px: a small word that pops and rises (pets.css `.petwoof`). */
export function woofAt(parent: HTMLElement, x: number, y: number, word = "WOOF!"): void {
  const w = document.createElement("div");
  w.className = "petwoof disp";
  w.textContent = word;
  w.style.left = `${Math.round(x)}px`;
  w.style.top = `${Math.round(y)}px`;
  parent.append(w);
  window.setTimeout(() => w.remove(), NOTE_MS);
}
